import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOskVm } from '../osk-vm.model';
import { INewOskIm } from '../new-osk-im.model';
@Injectable({ providedIn: 'root' })
export class NewOskService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/NewOsk`;
  }
  post(newOskIm: INewOskIm): Observable<IOskVm> {
    const headers = this.createHeaders();
    return this.http.post<IOskVm>(this.baseUrl, newOskIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
